// extracted by mini-css-extract-plugin
module.exports = {"assignMenuContainer":"_2c-dpZdnuiTnG_qLlDZYi5","header":"tuBsH4IiVKWSYgb2bAq-q","options":"H0weNZU_OSQqfCrzwr9Gu","option":"Ow1eFW3tN-Uui_4r6QgRq"};